// extracted by mini-css-extract-plugin
module.exports = {"ingredientList":"ingredients-list_ingredientList__1jFf6"};